<div class="row row1">
  <div class="col-sm-12 header-container">
    <h2>Manage Accounts</h2>
  </div>
</div>


<div class="panel panel-card">
  <div class="panel-heading">
    <div class="panel-heading">
      <div class="card-header bp-card-header">
        <i class="fas fa-user payment-options-icon" style="float: left;"></i>
        <p class="font-weight-light bp-text">My Accounts</p>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="panel-body manage-accounts-content">
      <div class="row" style="margin-left: 10px;">
        <button type="button" class="btn btn-light bp-text bp-medium-text add-acct-btn" (click)="goToRegister()">+ ADD ACCOUNT</button>
        <hr />

        <div *ngFor="let customerInfo of allCustomerInfo">
          <p class="card-text account-details-text bp-text">
            <b>{{ customerInfo?.Address1 == null ? '--' : customerInfo.Address1 }}</b>
            <b>
              {{ customerInfo?.Address2 == null ? '' : customerInfo.Address2 }}
              <br />
            </b>
            {{ customerInfo?.City == null ? '--' : customerInfo?.City }}, {{ customerInfo?.State == null ? '--' : customerInfo?.State }} {{ customerInfo?.Zipcode == null ? '--' : customerInfo?.Zipcode }}
            <br />
            {{ customerInfo?.AccountNumber == null ? '--' : customerInfo.AccountNumber }}
          </p>
          <hr />
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/manage-accounts-container/manage-accounts-container.component.html